// A response the caller cannot use: it never arrived, did not come from Cygnetise, or is not what
// the caller expects. The message is fixed per kind, so no response text reaches AppSignal through
// it; what varies travels in `details`.
export default class UnexpectedResponseError extends Error {
  constructor(kind, details) {
    super(UnexpectedResponseError.messages[kind]);
    this.name = "UnexpectedResponseError";
    this.kind = kind;
    this.details = details;
  }

  static get messages() {
    return {
      network: "Request did not complete",
      unavailable: "Cygnetise load balancer returned an error",
      intermediary: "Response did not come from Cygnetise",
      server_error: "Cygnetise returned a server error",
      unexpected_format: "Cygnetise returned an unexpected format",
    };
  }
}
